
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  components: {},
  setup() {
    const state = reactive({})

    return {
      ...toRefs(state),
    }
  },
})

export const useNotice = () => {
  return {
    show(message: string) {
      console.log(message)
    },
    warn(message: string) {
      console.log(message)
    },
    error(message: string) {
      console.log(message)
    },
  }
}
